/* app/js/src/components/scheduler/schedulerAside/schedulerAside.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  position: relative;
  z-index: 9;
}
:host > div {
  -webkit-box-shadow: 3px 0 10px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 3px 0 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 3px 0 10px 0 rgba(0, 0, 0, 0.1);
  -ms-transform: translate(15px, 0);
  -webkit-transform: translate(15px, 0);
  transform: translate(15px, 0);
  padding: 10px 5px;
  position: absolute;
  right: 0;
  top: calc(50% - 15px);
  background-color: inherit;
  border-radius: 0 8px 8px 0;
  cursor: pointer;
}
:host > div::before {
  content: " ";
  position: absolute;
  top: -10%;
  height: 120%;
  left: -4px;
  width: 6px;
  background-color: inherit;
}
:host > div svg path {
  fill: #879baf;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
:host > div:hover svg path {
  fill: #232f3a;
}
:host.collapsed {
  width: 5px;
}
:host.collapsed > div svg path {
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
library-wrapper-component {
  overflow: hidden;
}
/*# sourceMappingURL=schedulerAside.component.css.map */
